import React from 'react';
import ImageGalleryItem from 'components/ImageGalleryItem';
import { ImageGalleryBox } from './ImageGallery.styled';
import { useContext } from 'react';
import GalleryContext from '../GalleryContext';

const ImageGallery = () => {
  const { state } = useContext(GalleryContext);
  const { pictures } = state;
  //фун. делаем масив изображений для галереи
  const newPictures = pictures.flatMap(e => e);
  return (
    <ImageGalleryBox>
      {newPictures.map(({ webformatURL, id, tags }) => (
        <ImageGalleryItem
          key={id}
          item={webformatURL}
          id={id}
          describe={tags}
        />
      ))}
    </ImageGalleryBox>
  );
};

export default ImageGallery;
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// const ImageGallery = () => {
//   const { listOfPictures, getPhotoForModal } = useContext(GalleryContext);
//   return (
//     <ImageGalleryBox>
//       {listOfPictures.map(({ webformatURL, id, tags }) => (
//         <ImageGalleryItem
//           key={id}
//           item={webformatURL}
//           id={id}
//           describe={tags}
//           pictureForModal={getPhotoForModal}
//         />
//       ))}
//     </ImageGalleryBox>
//   );
// };
